<template>
	<div class="userManage">
		<!-- 筛选条件 -->
		<filterBar s_name="校级管理员" @searchName="setSearchName" @school_search="setSchool_search"
			:getSchoolArray="getSchoolArray">
		</filterBar>
		<!-- 列表 -->
		<el-card shadow="hover" style="margin-top: 10px;">
			<div slot="header" class="clearfix">
				<span>用户列表({{tableDataCount}})</span>
				<el-button style="float: right; padding: 3px 0" type="text" @click="addDialogVisible = true">添加校级管理员
				</el-button>
			</div>
			<el-table :data="showDate()" style="width: 100%;margin-bottom: 20px;">
				<el-table-column type="index" label="#" align="center">
					<template slot-scope="scope">
						{{scope.$index + 1}}
					</template>
				</el-table-column>
				<el-table-column prop="name" label="姓名">
					<template slot-scope="scope">
						<div v-html="scope.row.name.replace(searchName,'<font  color=\'red\'>'+searchName+'</font>')">
						</div>
					</template>
				</el-table-column>
				<el-table-column prop="loginID" label="登录账号" width="150">
					<template slot-scope="scope">
						<div
							v-html="scope.row.loginID.replace(searchName,'<font  color=\'red\'>'+searchName+'</font>')">
						</div>
					</template>
				</el-table-column>
				<el-table-column prop="loginPwd" label="登录密码"></el-table-column>
				<el-table-column prop="phone" label="手机号"></el-table-column>
				<el-table-column label="所属学校" width="200">
					<template slot-scope="scope">
						{{showSchoolName(scope.row.schoolID)}}
					</template>
				</el-table-column>
				<el-table-column label="用户状态" width="100px">
					<template slot-scope="scope">
						<el-switch @change="editUserState(scope.row)" v-model="scope.row.state==1?true:false"
							active-color="#13ce66" inactive-color="#ff4949">
						</el-switch>
					</template>
				</el-table-column>
				<el-table-column prop="stopTime" label="到期时间" width="200"></el-table-column>
				<el-table-column prop="createTime" label="创建时间" width="200"></el-table-column>
				<el-table-column label="操作" fixed="right" width="200">
					<template slot-scope="scope">
						<el-button size="mini" style="margin-right: 10px;" icon="el-icon-edit" @click="edit(scope.row)">
							编辑</el-button>

						<el-popconfirm title="确定要删除吗" @confirm="del(scope.row)">
							<el-button size="mini" type="danger" icon="el-icon-delete" slot="reference">
								删除</el-button>
						</el-popconfirm>
					</template>
				</el-table-column>
			</el-table>
			<!-- 分页 -->
			<el-pagination background layout="total, sizes, prev, pager, next, jumper" :total="tableDataCount"
				class="pagination" @size-change="sizeChange" @current-change="currentChange">
			</el-pagination>
		</el-card>
		<!-- 添加 -->
		<edit @before-close="closeEditDialog" :outerVisible="addDialogVisible" dialogType="add" :roleID="roleID"
			:getSchoolArray="getSchoolArray">
		</edit>
		<!-- 编辑 -->
		<edit @before-close="closeEditDialog" :outerVisible="editDialogVisible" dialogType="up" :objdata="dialogModels"
			:roleID="roleID" :getSchoolArray="getSchoolArray"></edit>
	</div>
</template>

<script>
	import filterBar from '@/components/org-filterbar/filterBar1.vue'
	import edit from './user/editSchool.vue'

	import {
		mapGetters
	} from 'vuex'

	export default {
		data() {
			return {
				//分页数据
				data: [],
				page_size: 10,
				page_current: 1,
				tableDataCount: 0,
				//页面列表 筛选条件
				searchName: '',
				school_search: '',
				//添加 修改
				editDialogVisible: false,
				addDialogVisible: false,
				dialogModels: {},
				roleID: 2,
				getSchoolArray: []
			}
		},
		computed: {
			...mapGetters(['getUserInfo'])
		},
		created() {
			this.loadData()
		},
		components: {
			filterBar,
			edit
		},
		methods: {
			async loadData() {
				await this.$http.get('api/Org/GetSchools').then(res => {
					this.getSchoolArray = res.data.data
				})
				await this.$http.get('api/User/GetUsers/' + this.roleID).then(res => {
					this.data = res.data.data
				})
			},
			//筛选条件
			setSearchName(val) {
				this.searchName = val
				this.page_current = 1
			},
			setSchool_search(val) {
				this.school_search = val
			},
			//分页
			sizeChange(e) {
				this.page_size = e
			},
			currentChange(e) {
				this.page_current = e
			},
			showDate() {
				if (this.data) {
					let _data = this.data
						.filter(item => item.name &&
							(
								item.name.search(this.searchName) > -1 ||
								item.loginID.search(this.searchName) > -1
							) &&
							item.schoolID.search(this.school_search) > -1
						)
					this.tableDataCount = _data.length
					return _data.slice((this.page_current - 1) * this.page_size, this.page_current * this.page_size)
				}
			},
			showSchoolName(val) {
				let school = this.getSchoolArray.find(item => {
					return item.id == val
				})
				return school.name
			},
			//修改用户状态
			editUserState(users) {
				users.state = users.state == 0 ? 1 : 0
				this.$http.get('api/User/EditUserState/' + users.id + '/' + users.state)
					.then(res => {

					})
					.catch(ex => {
						this.$message({
							message: ex.body,
							type: 'danger'
						})
					})
			},
			del(data) {
				this.$http.get('api/User/DelUsersOne/' + data.id)
					.then(res => {
						if (res.data.code == "1") {
							this.$message({
								message: "删除用户成功",
								type: 'success'
							})
							this.loadData()
						}
					})
					.catch(ex => {
						this.$message({
							message: ex.body,
							type: 'danger'
						})
					})
			},
			edit(val) {
				this.dialogModels = val
				this.editDialogVisible = true
			},
			closeEditDialog(val) {
				//关闭所有弹出框
				this.editDialogVisible = false
				this.addDialogVisible = false
				//刷新列表数据
				if (val == true) {
					this.loadData()
				}
			}
		}

	}
</script>

<style lang="scss">
	.userManage {
		.pagination {
			margin: 10px 0;
			text-align: center;
		}
	}
</style>
